const socialNetworksAppKeys = {
  googleApi: process.env.NODE_ENV !== 'production' ? '' : 'AIzaSyDgQLZIaiZyhDfH1pzhlaycTGM-fP4Ze-I',
};

const general = {
  socialNetworksAppKeys,
};

export default general;
